import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { stringify } from 'hub-http/helpers/params';
import { buildUrl, parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
export const getUpgradePageUrl = (upgradeSource, params) => {
  if (!upgradeSource) {
    console.warn(`Expected upgradeSource for path 'upgrade' but got '${upgradeSource}'`);
  }
  const portalId = PortalIdParser.get();
  const isQA = enviro.isQa() || window.location.hostname.indexOf('wthubspot') >= 0;
  const baseUrl = getFullUrl('app', {
    envOverride: isQA ? 'qa' : 'prod'
  });
  const {
    protocol,
    hostname
  } = parseUrl(baseUrl);
  return buildUrl({
    protocol,
    hostname,
    path: `/pricing/${portalId}/upgrade`,
    query: stringify(Object.assign({
      upgradeSource
    }, params))
  });
};
export const openUpgradePageInNewTab = upgradeKey => {
  const redirectUrl = getUpgradePageUrl(upgradeKey);
  window.open(redirectUrl, '_blank');
};